export var HashType;
(function (HashType) {
    HashType["data"] = "data";
    HashType["type"] = "type";
    HashType["data1"] = "data1";
})(HashType || (HashType = {}));
export var DepType;
(function (DepType) {
    DepType["code"] = "code";
    DepType["depGroup"] = "dep_group";
})(DepType || (DepType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJmYWNlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbnRlcmZhY2VzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFBLE1BQU0sQ0FBTixJQUFZLFFBSVg7QUFKRCxXQUFZLFFBQVE7SUFDbEIseUJBQWEsQ0FBQTtJQUNiLHlCQUFhLENBQUE7SUFDYiwyQkFBZSxDQUFBO0FBQ2pCLENBQUMsRUFKVyxRQUFRLEtBQVIsUUFBUSxRQUluQjtBQUVELE1BQU0sQ0FBTixJQUFZLE9BR1g7QUFIRCxXQUFZLE9BQU87SUFDakIsd0JBQWEsQ0FBQTtJQUNiLGlDQUFzQixDQUFBO0FBQ3hCLENBQUMsRUFIVyxPQUFPLEtBQVAsT0FBTyxRQUdsQiJ9